import { z } from 'zod';
import { isoDateSchema, isoDateTimeSchema, uuidSchema } from './common.js';
/** Vehicles: the business share of each truck, and what the year's costs were. */
const minor = z.string().regex(/^-?\d{1,15}$/);
export const vehicleYearSchema = z.object({
    vehicleId: uuidSchema,
    name: z.string(),
    plate: z.string().nullable(),
    technicianId: uuidSchema.nullable(),
    technicianName: z.string().nullable(),
    /** The share in force, 0 to 100. */
    businessUsePercent: z.string(),
    kmBusiness: z.string(),
    kmTotal: z.string(),
    /** What the year's log says the share is, or null without a log. */
    logSharePercent: z.string().nullable(),
    fuelMinor: minor,
    repairsMinor: minor,
    insuranceMinor: minor,
    itcMinor: minor,
    personalShareMinor: minor,
    itcRepayMinor: minor,
    archived: z.boolean(),
});
export const saveVehicleRequestSchema = z.object({
    vehicleId: uuidSchema.nullable().optional(),
    name: z.string().trim().min(1).max(120),
    plate: z.string().trim().max(20).nullable().optional(),
    description: z.string().trim().max(200).nullable().optional(),
    technicianId: uuidSchema.nullable().optional(),
    businessUsePercent: z.number().min(0).max(100),
});
export const mileageLogSchema = z.object({
    id: uuidSchema,
    vehicleId: uuidSchema,
    loggedOn: isoDateSchema,
    kilometres: z.string(),
    business: z.boolean(),
    purpose: z.string().nullable(),
    createdAt: isoDateTimeSchema,
});
export const addMileageRequestSchema = z.object({
    vehicleId: uuidSchema,
    loggedOn: isoDateSchema,
    kilometres: z.number().positive().max(100000),
    business: z.boolean().default(true),
    purpose: z.string().trim().max(200).nullable().optional(),
});
//# sourceMappingURL=vehicles.js.map